import {initialState as searchRequestInitialState} from '../search-request/search-request-reducer';
import {v4 as uuidV4} from 'uuid';
import SearchUtils from '../search/search-utils';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import CityAPI from '../api/city';
import DestinationAPI from '../api/destination';
import Config from 'config';

export const Page = Object.freeze({
    AIRPORT: 'airport',
    CATEGORY: 'category',
    CHECKOUT: 'checkout',
    CITY: 'city',
    DESTINATION: 'destination',
    EVENT: 'event',
    FACILITY: 'facility',
    HOME: 'home',
    LEGAL: 'legal',
    MID_FUNNEL: 'mid_funnel',
    NOT_FOUND: 'not_found',
    REDIRECT: 'redirect',
    SEARCH: 'search',
});

export const parseSlug = slug => slug.replace(/-parking$/, '');

export function foldWithSearchState({
    state,
    type,
    latitude,
    longitude,
    timezone,
    query = {},
    cookies,
}) {
    const nextState = {
        ...state,
        searchRequest: {
            ...searchRequestInitialState,
            monthly: query.monthly === true || query.monthly === 'true',
            latitude,
            longitude,
            id: uuidV4(),
            pageType: type,
            ...SearchUtils.createTimeWindowParams(type, query, timezone),
        },
    };

    // NOTE: if the cookie is set to 'false' or doesn't exist then isInfoPanelVisible should be true, if the cookie is set to 'true' then isInfoPanelVisible should be false
    const isInfoPanelVisible = !cookies
        ? true
        : cookies[Config.infoPanelCookie] === 'false'
        ? true
        : !Boolean(cookies[Config.infoPanelCookie]); // eslint-disable-line no-extra-boolean-cast

    return {
        ...nextState,
        search: {
            data: {
                ...SearchUtils.defaultSearchSettings,
                searchType: type,
                breadcrumbs: SearchUtils.prepareBreadcrumbs(nextState, type),
                isInfoPanelVisible,
            },
        },
    };
}

export function fetchCity(state, cityParam) {
    const {slug} = state.city.data;
    const citySlug = parseSlug(cityParam);

    // if `state` already has the city with this slug, use that instead of calling the API
    return isNil(slug) || !isEqual(citySlug, slug)
        ? CityAPI.get(citySlug).then(res => res.data)
        : state.city;
}

export function fetchDestination(params, state, citySlug) {
    const slug = parseSlug(params.slug);
    const {relative_url: relativeUrl} = state.destination.data;

    // if `state` already has the destination with this slug, use that instead of calling the API
    return isNil(relativeUrl) || !isEqual(parseSlug(relativeUrl), slug)
        ? DestinationAPI.getBySlug(citySlug, slug).then(res => res.data)
        : state.destination;
}

export function isMonthlyPage(route) {
    // if "monthly" is the second part of the URL then set as a monthly search
    return route?.location?.pathname.split('/')[2] === 'monthly';
}
